export default __webpack_public_path__ + "static/media/IMG_4916.c81b5ac1.png";